import { useEffect } from 'react'
import { useIndexedDB } from './services/indexedDB'
import { MindMapCanvas } from './components/mindmap/MindMapCanvas'
import './styles/globals.css'

function App() {
  const { init, isInitialized } = useIndexedDB()

  useEffect(() => {
    init()
  }, [init])

  if (!isInitialized) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">StoryForge 초기화 중...</h2>
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
        </div>
      </div>
    )
  }

  return <MindMapCanvas />
}

export default App
